import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";

export const CREATE_SUPPLIER = "supplierNetwork/CREATE_SUPPLIER";
export const UPDATE_SUPPLIER = "supplierNetwork/UPDATE_SUPPLIER";
export const DELETE_SUPPLIER = "supplierNetwork/DELETE_SUPPLIER";
export const RETRIEVE_SUPPLIERS = "supplierNetwork/RETRIEVE_SUPPLIERS";

export const SEARCH_SUPPLIERS = "supplierNetwork/SEARCH_SUPPLIERS";
export const CONNECT_GROUP_SUPPLIER = "supplierNetwork/CONNECT_GROUP_SUPPLIER";

const CREATE_SUPPLIER_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_SUPPLIER_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_SUPPLIER_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_SUPPLIERS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const SEARCH_SUPPLIERS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CONNECT_GROUP_SUPPLIER_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {
  // A map of maps, where the first key is the "group-id" returning a
  // dictionary of <supplier_id, supplier>
  supplierConnections: {},

  discoverSearchResults: [],
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_SUPPLIER: {
        break;
      }

      case UPDATE_SUPPLIER: {
        draft.supplierConnections[action.groupId][
          _.get(action.supplier, "supplier_id")
        ] = action.supplier;
        break;
      }

      case DELETE_SUPPLIER: {
        break;
      }

      case RETRIEVE_SUPPLIERS: {
        draft.supplierConnections[action.groupId] = {};
        action.suppliers.forEach((s) => {
          draft.supplierConnections[action.groupId][s.supplier_id] = s;
        });
        break;
      }

      case SEARCH_SUPPLIERS: {
        draft.discoverSearchResults = action.supplierSearchResult;
        break;
      }

      case CONNECT_GROUP_SUPPLIER: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const createSupplier = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "supplier_network.createSupplier",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_SUPPLIER_NETWORK_CREATE_SUPPLIER,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_SUPPLIER });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "supplier_network.createSupplier",
                },
            history
          )
        );
        dispatch(
          retrieveSuppliers({
            values,
            successState: {
              context: "supplier_network.createSupplier.retrieveSuppliers",
            },
            errorState: (error) => ({
              context: "supplier_network.createSupplier.retrieveSuppliers",
              notificationType: "alert",
              ...error,
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_SUPPLIER_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "supplier_network.createSupplier",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateSupplier = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "supplier_network.updateSupplier",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_SUPPLIER_NETWORK_UPDATE_SUPPLIER,
        values
      )
      .then((response) => {
        const groupId = _.get(values, "group_id");
        const supplier = _.get(response, "data.supplier");

        dispatch({ type: UPDATE_SUPPLIER, groupId, supplier });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "supplier_network.updateSupplier",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_SUPPLIER_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "supplier_network.updateSupplier",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteSupplier = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "supplier_network.deleteSupplier",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_SUPPLIER_NETWORK_DELETE_SUPPLIER,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_SUPPLIER });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "supplier_network.deleteSupplier",
                },
            history
          )
        );
        dispatch(
          retrieveSuppliers({
            values,
            successState: {
              context: "supplier_network.deleteSupplier.retrieveSuppliers",
            },
            errorState: (error) => ({
              context: "supplier_network.deleteSupplier.retrieveSuppliers",
              notificationType: "alert",
              ...error,
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_SUPPLIER_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "supplier_network.deleteSupplier",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveSuppliers = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "supplier_network.retrieveSuppliers",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_SUPPLIER_NETWORK_RETRIEVE_SUPPLIERS,
        values
      )
      .then((response) => {
        const groupId = values.group_id;
        const suppliers = _.get(response, "data.suppliers", []);

        dispatch({ type: RETRIEVE_SUPPLIERS, groupId, suppliers });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "supplier_network.retrieveSuppliers",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_SUPPLIERS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "supplier_network.retrieveSuppliers",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const searchSuppliers = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "supplier_network.searchSuppliers",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_SUPPLIER_NETWORK_SEARCH_SUPPLIERS,
        values
      )
      .then((response) => {
        const supplierSearchResult = _.get(response, "data.search_result", []);

        dispatch({ type: SEARCH_SUPPLIERS, supplierSearchResult });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "supplier_network.searchSuppliers",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = SEARCH_SUPPLIERS_ERRORS;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "supplier_network.searchSuppliers",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const connectGroupSupplier = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "supplier_network.connectGroupSupplier",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_SUPPLIER_NETWORK_CONNECT_GROUP_SUPPLIER,
        values
      )
      .then((response) => {
        dispatch({ type: CONNECT_GROUP_SUPPLIER });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "supplier_network.connectGroupSupplier",
                },
            history
          )
        );
        dispatch(
          retrieveSuppliers({
            values,
            successState: {
              context:
                "supplier_network.connectGroupSupplier.retrieveSuppliers",
            },
            errorState: (error) => ({
              context:
                "supplier_network.connectGroupSupplier.retrieveSuppliers",
              notificationType: "alert",
              ...error,
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = CONNECT_GROUP_SUPPLIER_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "supplier_network.connectGroupSupplier",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
